import { ImageIcon } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

export const ImagePlaceholder = () => (
  <div className='w-full sm:w-32 h-48 sm:h-32 bg-gray-100 rounded-lg flex items-center justify-center'>
    <div className='text-center'>
      <ImageIcon className='w-8 h-8 text-gray-400 mx-auto mb-2' />
      <span className='text-xs text-gray-500'>
        <FormattedMessage id='noImage' defaultMessage='Нет изображения' />
      </span>
    </div>
  </div>
);
